import { defineAsyncComponent } from 'vue';

export const TableFilterMid = defineAsyncComponent(() => import('./TableFilterMid.vue'));
export const TableTopMid = defineAsyncComponent(() => import('./TableTopMid.vue'));
